import { useCallback } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { RESULTS_PATHNAME, SEARCH_QUERY_KEY } from '../constants';
import { isOnResultsPage } from '../utils/isOnResultsPage';
const ALLOWED_SEARCH_PARAM_KEYS = [SEARCH_QUERY_KEY, 'cat', 'tools'];
export const getResultsPagePath = (currentSearch, updatedSearchParams) => {
  const searchParams = new URLSearchParams(currentSearch);
  if (updatedSearchParams) {
    // Remove any allowed search parameters that are not being explicitly updated
    // This ensures only the parameters in updatedSearchParams are preserved
    for (const key of ALLOWED_SEARCH_PARAM_KEYS) {
      if (key in updatedSearchParams) {
        continue;
      }
      searchParams.delete(key);
    }
    for (const [key, value] of Object.entries(updatedSearchParams)) {
      searchParams.set(key, value);
    }
  }

  // Reset pagination when navigating to results page
  searchParams.delete('page');
  const searchParamsString = searchParams.toString();
  return `${RESULTS_PATHNAME}${searchParamsString ? `?${searchParamsString}` : ''}`;
};
export const useNavigateToResultsPage = () => {
  const navigate = useACNavigate();
  const location = useLocation();
  return useCallback(searchParams => {
    if (isOnResultsPage(location.pathname)) {
      navigate(getResultsPagePath(location.search, searchParams), {
        replace: true
      });
    } else {
      navigate(getResultsPagePath(undefined, searchParams));
    }
  }, [navigate, location]);
};